<template>
  <div v-if="groups && types">
    <h1>Groups</h1>
    <v-select
      label="Filter by type"
      v-model="typeid"
      :items="computedTypes"
      item-value="id"
      item-text="name"
      outline
    >
      <template slot="append-outer" v-if="typeid">
        <a @click="typeid = null">
          <v-icon>clear</v-icon>
        </a>
      </template>
    </v-select>
    <v-btn :to="computedAssignLink" v-if="typeid">Assign</v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedGroups"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'group', params:{id: props.item.id}}">{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.type.name }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Groups",
  metaInfo() {
    return {
      title: "Groups",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedGroups() {
      if (!this.groups) {
        return undefined;
      }
      const typesMap = this.types
        ? convertListOfObjectsToMap(this.types, "id")
        : undefined;
      return this.groups.map(g => {
        const type = typesMap ? typesMap[g.typeid] : undefined;
        return { ...g, type };
      });
    },
    computedTypes() {
      if (!this.types) {
        return undefined;
      }
      return this.types.filter(t => t.groups);
    },
    computedAssignLink() {
      return this.typeid
        ? { name: "groupAssign", params: { id: this.typeid } }
        : undefined;
    }
  },
  data() {
    return {
      groups: null,
      types: null,
      typeid: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Type",
          value: "type.name"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchGroups() {
      nbmlaw
        .get(`/cors/admin/directory/groups`, {
          params: { typeid: this.typeid }
        })
        .then(response => {
          // console.log(response.data);
          this.groups = response.data;
        });
    },
    fetchTypes() {
      nbmlaw.get(`/cors/admin/directory/types`).then(response => {
        // console.log(response.data);
        this.types = response.data;
      });
    },
    update() {
      this.fetchGroups();
      this.fetchTypes();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.typeid = this.$route.params.id
          ? Number(this.$route.params.id)
          : null;
        this.update();
      }
    },
    typeid: {
      handler() {
        this.$router.push({ name: "groups", params: { id: this.typeid } });
      }
    }
  }
};
</script>
